const SearchBar = ({ searchTerm, setSearchTerm }) => {
  return (
    <div className="w-full justify-start">
      <input
        type="text"
        placeholder="Search by company name, symbol, or analysis status..."
        className="border mb-0 p-2 ml-4 mt-2"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>
  );
};

export default SearchBar;
